/*
  WhyELearning.js
  Seção de diferenciais do E-Learning — por que escolher os cursos online da FMP.
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKTypography from "components/MKTypography";

// InfoCard reutilizado da homepage
import SimpleInfoCard from "examples/Cards/InfoCards/SimpleInfoCard";

function WhyELearning() {
  return (
    <MKBox component="section" py={{ xs: 6, md: 10 }}>
      <Container>
        <Grid container justifyContent="center" mb={6}>
          <Grid item xs={12} md={8} textAlign="center">
            <MKTypography variant="h3" mb={1}>
              Aprendizado flexível com padrão internacional
            </MKTypography>
            <MKTypography variant="body2" color="text">
              Os cursos de e-Learning da FMP Soluções são desenvolvidos em parceria com a Templar
              Executives do Reino Unido, garantidos pelo NCSC (National Cyber Security Centre), e
              podem ser hospedados internamente ou na infraestrutura da FMP — adaptados ao seu
              setor, idioma e requisitos regulatórios.
            </MKTypography>
          </Grid>
        </Grid>

        <Grid container item xs={12} justifyContent="center">
          <Grid
            item
            xs={12}
            md={4}
            sx={{ ml: { xs: 0, md: "auto" }, mr: { xs: 0, md: 6 }, mb: { xs: 4, md: 0 } }}
          >
            <Stack spacing={{ xs: 4, md: 8 }}>
              <SimpleInfoCard
                icon="verified"
                title="Certificação NCSC Assured"
                description="Todos os cursos são garantidos pelo National Cyber Security Centre do Reino Unido, com certificado de conclusão personalizado e reconhecimento internacional."
              />
              <SimpleInfoCard
                icon="tune"
                title="Adaptado ao seu setor"
                description="Conteúdo customizável por setor — saúde, aviação, serviços financeiros, governo — com cenários e legislação específicos para o contexto brasileiro."
              />
            </Stack>
          </Grid>
          <Grid
            item
            xs={12}
            md={4}
            sx={{ mr: { xs: 0, md: "auto" }, ml: { xs: 0, md: 6 }, mb: { xs: 4, md: 0 } }}
          >
            <Stack spacing={{ xs: 4, md: 8 }}>
              <SimpleInfoCard
                icon="bar_chart"
                title="Relatórios gerenciais"
                description="Monitoramento e rastreamento da atividade dos usuários em tempo real — ideal para demonstrar conformidade com LGPD, PCI DSS e normas setoriais."
              />
              <SimpleInfoCard
                icon="language"
                title="Disponível em múltiplos idiomas"
                description="Os cursos podem ser disponibilizados em português, inglês e outros idiomas sob solicitação, garantindo alcance em toda a América Latina."
              />
            </Stack>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default WhyELearning;
